// extracted by mini-css-extract-plugin
module.exports = {"divider":"AttachmentAddPopup_divider__3MVK4","menu":"AttachmentAddPopup_menu__22Myl","menuItem":"AttachmentAddPopup_menuItem__3YxJE","tip":"AttachmentAddPopup_tip__2lgZ2"};